import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Grid from '@material-ui/core/Grid'

import './Featurescards.css'
// images
import logoimg from '../../img/4.png'

const Featurecards = (props) => {
  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      xs={12}
      sm={4}
      className="pcc---buyCard px-3 my-3 position-relative"
      
    >
      <img src={logoimg} className="PCC---PcatFeater_card_hover" />
        <div className="pcc---buyCardBox py-3  mt-lg-4">
            <Grid
              container
              direction="row"
              justify="flex-start"
              xs={12}
             
              className="pcc---buyCard px-3 my-3"
            >
            <Grid
              container
              direction="column"
              justify="flex-start"
              xs={12}
              sm={3}
            >
              
              <img src={props.img} className="mx-auto cardimage"></img></Grid>
             <Grid
              container
              direction="column"
              justify="flex-start"
              xs={12}
              sm={9}
              className=""
            ><h4 className="text-left pl-0"> {props.title}</h4>
            <p className="text-left">{props.discription}</p></Grid>
           
            </Grid>
          </div>
    </Grid>
  );
}

export default Featurecards;
